import { render, staticRenderFns } from "./WidgetHidden.vue?vue&type=template&id=fe11969e&lang=pug"
import script from "./WidgetHidden.vue?vue&type=script&lang=js"
export * from "./WidgetHidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports